<template>
  <span
    v-if="getText !== '' "
    class="resulticon"
    :class="getColor"
  >
    {{ getText }}
    <div class="toggle-tooltip">
      {{ getTextToolTip }}
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    getColor: function() {
      if(this.value === null || this.value === ''){
        return "";
      }
      let css = "";
      switch(this.value){
        case "NEXT_BALL_OO":
          css = "o1";
          break;
        case "NEXT_BALL_OE":
          css = "o2";
          break;
        case "NEXT_BALL_UO":
          css = "o3";
          break;
        case "NEXT_BALL_UE":
          css = "o3";
          break;
        default:
          css = "";
          break;
      }
      return css;
    },
    getText: function() {
      if(this.value === null || this.value === ''){
        return "";
      }
      let css = "";
      switch(this.value){
        case "NEXT_BALL_OO":
          css = "TL";
          break;
        case "NEXT_BALL_OE":
          css = "TC";
          break;
        case "NEXT_BALL_UO":
          css = "XL";
          break;
        case "NEXT_BALL_UE":
          css = "XC";
          break;
        default:
          css = "";
          break;
      }
      return css;
    },
    getTextToolTip: function() {
      let text = "";
      switch(this.value){
        case "NEXT_BALL_OO":
          text = "Tài/Lẻ";
          break;
        case "NEXT_BALL_OE":
          text = "Tài/Chẵn";
          break;
        case "NEXT_BALL_UO":
          text = "Xỉu/Lẻ";
          break;
        case "NEXT_BALL_UE":
          text = "Xỉu/Chẵn";
          break;
        default:
          text = "";
          break;
      }
      return text;
    },
  },
}
</script>

